export default "__VITE_ASSET__7fd68e9c__"